import React from 'react';
import './App.css';
import {Header} from "./components/header";
import Footer from "./components/footer";
import {CalculationBody} from "./components/Calculation";
import {Button} from "./components/Button";
import {PackagePicker} from "./components/nezgodaPicker";
import languages from "./collections/languages"
import {connect} from "react-redux";
import ReactGA from 'react-ga';
class Application extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            isPicked : false
        };
        this.handlePick= this.handlePick.bind(this);
        const trackingId = "UA-151570546-1"; // Replace with your Google Analytics tracking ID
        ReactGA.initialize(trackingId);
    }

handlePick(){
        this.setState({
            isPicked: true
        })
}
    render() {
        return (

            <div className="App flex-center grow-1 wrap">
                <Header
                    insuranceImage={require ( './images/PiktogramNezgoda.jpg' )}
                    insuranceName={!languages[this.props.lang] ? " " : languages[this.props.lang].insuranceType.insurance1}
                    className={"w-100"}/>
                {!this.state.isPicked &&
                    <PackagePicker
                        handlePick={this.handlePick}/>
                }
                {this.state.isPicked &&
                <div className={"flex-start wrap"}>
                    <div className={"flex-between flex-full wrap"}>
                <Button
                    text={"< Nazad"}
                    class={"button-small"}
                onClick={()=>{this.setState({isPicked: false})}}/>
                    <h4 style={{fontSize : "24px", fontWeight: "500"}}>Izabrani paket: {this.props.product}</h4>
                    </div>
                <CalculationBody/>
                </div>}
                <Footer/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
        insuranceType : state ? state.insuranceType : '' ,
        product: state ? state.product : ''
    });
};

export const App = connect ( mapStateToProps ) ( Application );

export default App;
